import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../../context/Datacontext'

import AllList from '../AllList'
import { fetchAllClient } from '../../services/managerApi/clientsApi'

export default function ClientsLists() {
  const { BeURL, showAlert, currentUser } = useContext(DContext)

  const [client, setClient] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerpage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [totalClient, setTotalClient] = useState(0)

  useEffect(() => {
    const fetchClients = async () => {
      await fetchAllClient(BeURL, showAlert, setClient, currentUser.company.companyId, currentPage, rowsPerPage, setTotalClient, setTotalPage)
    }

    fetchClients()
  }, [currentPage, rowsPerPage, BeURL])

  useEffect(() => {
    setCurrentPage(1)
  }, [rowsPerPage])

  // Client useState


  const handlePagination = (dir) => {
    if (dir === 'prev' && currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
    if (dir === 'next' && currentPage < totalPage) {
      setCurrentPage(prev => prev + 1);
    }
  };

  return (
    <div className="min-h-[80vh] p-6">

      <h2 className="text-center text-2xl font-semibold text-primary-600 mb-8">
        Clients Details
      </h2>

      <div
        className="gap-6"
        style={{ alignContent: 'center' }}
      >
        <AllList client={client} />
      </div>



      {/* Pagination  */}

      <div>
        {/* Pagination Controls */}
        <div className=" mx-auto mt-3 flex justify-around items-center">
          <div className="flex items-center gap-2">
            <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
            <select
              id="recordsPerPage"
              value={rowsPerPage}
              onChange={e => setRowsPerpage(parseInt(e.target.value, 10))}
              className="ml-2 px-3 py-1 border rounded"
            >
              {[10, 20, 25, 50, 75, 100].map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
          <div className="text-sm">Total Client: {totalClient}</div>
        </div>
        <div className="flex justify-center items-center gap-4">
          <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('prev')}
            disabled={currentPage === 1}
          >
            chevron_left
          </span>
          <span>{currentPage} of {totalPage}</span>
          <span className={`td-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPage ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('next')}
            disabled={currentPage === totalPage}
          >
            chevron_right
          </span>
        </div>
      </div>
    </div>
  )
}
